export const environment = {
  production: true,
  name: 'prod',
  apiUrl: 'https://api.airgateway.com/',
  keycloakUrl: 'https://auth.airgateway.com',
  tracerUrl: 'https://tracer-api.airgateway.com',
  bpUrl: 'https://web.bookingpad.com/',
};
